// extracted by mini-css-extract-plugin
export default {"l":"f58ad5e4c9"};